import { render } from "./RdpId.vue?vue&type=template&id=52bc2814"
import script from "./RdpId.vue?vue&type=script&lang=js"
export * from "./RdpId.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__